import styled from 'styled-components';

export const ItemChartWrapper = styled.div`
	align-items: center;
	display: flex;
`;
